<div class="h-full">
  <div class="position-relative h-full">
    <svg [attr.id]="'svg-map-' + identifier" class="svg-map"
        width="100%" [attr.style]="svgStyle" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <g id="drag_root_{{identifier}}">

        <!-- Corridor Labels -->
        <g *ngIf="!isLoading">
          <text *ngFor="let label of corridorLabels"
            class="svg-text"
            [attr.x]="getXCoord(label.column) + 50" [attr.y]="getYCoord(label.row) + 53"
            [attr.transform]="'rotate(-90 ' + (getXCoord(label.column) + 50) + ' ' + (getYCoord(label.row) + 50) + ') 
              translate(0 1)'"
            text-anchor="middle" dominant-baseline="middle"
            font-size="60" fill="black">{{label.label}}
          </text>
        </g>

        <!-- Corridor segments -->
        <g *ngFor="let upright of uprights">
          <g *ngIf="uprightHasCorridor('top', upright.y_position, upright.x_position)">
            <line class="corridor-segment" stroke-width="5"
              [attr.x1]="getXCoord(upright.y_position) - separation - 2.475" [attr.x2]="getXCoord(upright.y_position) + dim + 3"
              [attr.y1]="getYCoord(upright.x_position) - separation" [attr.y2]="getYCoord(upright.x_position) - separation">
            </line>

            <line *ngIf="verticalCorridorsColumns.includes(upright.y_position+1)"
              class="corridor-segment" stroke-width="5"
              [attr.x1]="getXCoord(upright.y_position) + dim + 2.475" [attr.x2]="getXCoord(upright.y_position) + dim + separation + 2.475"
              [attr.y1]="getYCoord(upright.x_position) - separation" [attr.y2]="getYCoord(upright.x_position) - separation">
            </line>
          </g>

          <g *ngIf="uprightHasCorridor('right', upright.y_position, upright.x_position)">
            <line class="corridor-segment" stroke-width="5"
              [attr.x1]="getXCoord(upright.y_position) + dim + separation" [attr.x2]="getXCoord(upright.y_position) + dim + separation"
              [attr.y1]="getYCoord(upright.x_position) - separation" [attr.y2]="getYCoord(upright.x_position) + dim + 1">
            </line>

            <line *ngIf="horizontalCorridorsRows.includes(upright.x_position+1)"
              class="corridor-segment" stroke-width="5"
              [attr.x1]="getXCoord(upright.y_position) + dim + separation" [attr.x2]="getXCoord(upright.y_position) + dim + separation"
              [attr.y1]="getYCoord(upright.x_position) + dim" [attr.y2]="getYCoord(upright.x_position) + dim + separation">
            </line>
          </g>

          <g *ngIf="uprightHasCorridor('bottom', upright.y_position, upright.x_position)">
            <line class="corridor-segment" stroke-width="5"
              [attr.x1]="getXCoord(upright.y_position) - separation - 2.475" [attr.x2]="getXCoord(upright.y_position) + dim + 3"
              [attr.y1]="getYCoord(upright.x_position) + dim + separation" [attr.y2]="getYCoord(upright.x_position) + dim + separation">
            </line>

            <line *ngIf="verticalCorridorsColumns.includes(upright.y_position+1)"
              class="corridor-segment" stroke-width="5"
              [attr.x1]="getXCoord(upright.y_position) + dim + 2.475" [attr.x2]="getXCoord(upright.y_position) + dim + separation + 2.475"
              [attr.y1]="getYCoord(upright.x_position) + dim + separation" [attr.y2]="getYCoord(upright.x_position) + dim + separation">
            </line>
          </g>

          <g *ngIf="uprightHasCorridor('left', upright.y_position, upright.x_position)">
            <line class="corridor-segment" stroke-width="5"
              [attr.x1]="getXCoord(upright.y_position) - separation" [attr.x2]="getXCoord(upright.y_position) - separation"
              [attr.y1]="getYCoord(upright.x_position) - separation" [attr.y2]="getYCoord(upright.x_position) + dim + 1">
            </line>

            <line *ngIf="horizontalCorridorsRows.includes(upright.x_position+1)"
              class="corridor-segment" stroke-width="5"
              [attr.x1]="getXCoord(upright.y_position) - separation" [attr.x2]="getXCoord(upright.y_position) - separation"
              [attr.y1]="getYCoord(upright.x_position) + dim" [attr.y2]="getYCoord(upright.x_position) + dim + separation">
            </line>
          </g>
        </g>

        <g #upright [attr.id]="'upright-container-' + identifier">
          <g *ngFor="let upright of uprights;">
            <!-- Upright -->
            <g *ngIf="upright.id !== -1"
                [attr.id]="'upright-' + upright.id + '-' + identifier"
                class="svg-upright"
                [class.clickable]="isClickable(upright)"
                (mousedown)="handleUprightMouseDown($event)"
                (click)="isClickable(upright) && handleUprightClick(upright, $event)"
                [class.hovered]="focusedUprightsIDs.includes(upright.id)"
                (contextmenu)="menuItems = handleOpenContextMenu($event, upright)"
                (mousemove)="showTooltip($event, (getClassForStyle(upright) === 'OFF' && !isManager()) ? 'El administrador ha desactivado este puntal' : 'Click derecho para más opciones')"
                (mouseout)="hideTooltip()">

              <!-- Rounded square + Text + Icons -->
              <g *ngIf="getUprightAt(upright.x_position, upright.y_position) as support">

                <!--            White background square -->`
                <rect
                      [attr.x]="getXCoord(upright.y_position)" [attr.y]="getYCoord(upright.x_position)"
                      height="100" width="100" [attr.rx]="focusedUprightsIDs.includes(upright.id) ? 16 : 20" fill="white">
                </rect>

                <!--            Rounded square -->`
                <rect class="{{getClassForStyle(upright)}}"  
                      [attr.x]="getXCoord(upright.y_position)" [attr.y]="getYCoord(upright.x_position)"
                      height="100" width="100" [attr.rx]="focusedUprightsIDs.includes(upright.id) ? 16 : 20" fill="url(#pattern-checkers)">
                </rect>

                <!--            Sensor id text -->
                <text *ngIf="getClassForStyle(upright) !== 'ERROR' && getClassForStyle(upright) !== 'CONFIG'"
                      class="svg-text {{getClassForStyle(upright)}}-text"
                      [attr.x]="getXCoord(upright.y_position) + 50" [attr.y]="getYCoord(upright.x_position) + 53"
                      
                      text-anchor="middle" dominant-baseline="middle"
                      font-family="Verdana" font-size="30" fill="black">{{getDisplayName(upright)}}
                </text>

                <!--            Sensor ERROR icon -->
                <image *ngIf="getClassForStyle(upright) === 'ERROR'"
                      [attr.x]="getXCoord(upright.y_position) + 20" [attr.y]="getYCoord(upright.x_position) + 20"
                      href="assets/images/warning_icon.svg" width="60" height="60">
                </image>
              </g>

              <!--          CONFIG mask -->
              <g *ngIf="getClassForStyle(upright) === 'CONFIG'">
                <mask x="0" y="0" [attr.id]="'half-' + upright.id" class="CONFIG-mask">
                  <rect [attr.x]="getXCoord(upright.y_position)-3" [attr.y]="getYCoord(upright.x_position)+50"
                        width="120" height="55"/>
                </mask>
                <rect class="CONFIG-cover"
                      [attr.x]="getXCoord(upright.y_position)-1" [attr.y]="getYCoord(upright.x_position)+1"
                      height="100" width="102" rx="20" [attr.mask]="'url(#half-' + upright.id + ')'">
                </rect>
              </g>

              <!-- New events icon -->
              <g *ngIf="hasNewNotifications(upright)">
                <circle class="new-events-icon"
                  [attr.cx]="getXCoord(upright.y_position) + 85"
                  [attr.cy]="getYCoord(upright.x_position) + 10"
                  [attr.r]="25">
                  
                </circle>
                <text class="new-events-icon-text svg-text"
                  [attr.x]="getXCoord(upright.y_position) + 85" [attr.y]="getYCoord(upright.x_position) + 15"
                  text-anchor="middle" dominant-baseline="middle" font-size="45" font-family="Times New Roman">!
                </text>
              </g>
            </g>
          </g>

          <!-- Draft and config checkered pattern -->
          <pattern id="pattern-checkers" x="0" y="0" width="26" height="26" patternUnits="userSpaceOnUse">
            <rect class="checker" x="0" width="13" height="13" y="0"></rect>
            <rect class="checker" x="13" width="13" height="13" y="13"></rect>
          </pattern>
        </g>
      </g>
    </svg>

    <p-progressSpinner *ngIf="isLoading"></p-progressSpinner>

    <div class="zoom-panel m-5px">
      <button pButton pRipple type="button"
        class="p-button-rounded p-button-secondary p-button-text zoom-btn no-extra-label"
        (mousemove)="showTooltip($event, 'Centrar la vista')"
        (mouseout)="hideTooltip()"
        (click)="centerSVG(centerOn);$event.stopPropagation()">
        <span class="material-symbols-outlined">
          center_focus_weak
        </span>
      </button>
      <button pButton pRipple type="button"
        class="p-button-rounded p-button-secondary p-button-text zoom-btn no-extra-label"
        (mousemove)="showTooltip($event, 'Aumentar zoom (también puedes mantener Alt y usar la rueda del ratón)')"
        (mouseout)="hideTooltip()"
        (click)="zoomInSVG();$event.stopPropagation()">
        <span class="material-symbols-outlined">
          add_circle
        </span>
      </button>
      <button pButton pRipple type="button"
        class="p-button-rounded p-button-secondary p-button-text zoom-btn no-extra-label"
        (mousemove)="showTooltip($event, 'Disminuir zoom (también puedes mantener Alt y usar la rueda del ratón)')"
        (mouseout)="hideTooltip()"
        (click)="zoomOutSVG();$event.stopPropagation()">
        <span class="material-symbols-outlined">
          do_not_disturb_on
        </span>
      </button>
    </div>
  </div>

  <div *ngIf="identifier === 'default'" #tooltip class="tooltip-custom visibility-hidden"></div>

  <!-- <p-contextMenu [target]="upright" [model]="menuItems"
      [class.transparent]="menuItems.length <= 0">
  </p-contextMenu> -->
</div>